import { render, staticRenderFns } from "./PortfolioTermsModal.vue?vue&type=template&id=16183154&scoped=true"
import script from "./PortfolioTermsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioTermsModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PortfolioTermsModal.vue?vue&type=style&index=0&id=16183154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16183154",
  null
  
)

export default component.exports